// ANCHOR Model
import createModel, { createSelector } from 'react-scoped-model';

// ANCHOR Graph State
import { useAuthToken } from '@lyon/nodes/firebase/auth/auth-token-node';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getProviderForms } from '@lyon/utils/api/forms';

interface IProps {
  id: string;
}

export const ProviderFormData = createModel(({ id }: IProps) => {
  const token = useAuthToken();

  const response = useSWR(
    (
      token
        ? `/provider/${id}/forms`
        : null
    ),
    () => (
      token
        ? getProviderForms({
          providerId: id,
          token,
        })
        : undefined
    ),
  );

  return {
    ...response,
    providerId: id,
  };
}, {
  displayName: 'Models.ProviderFormData',
});

export const useProviderFormData = createSelector(
  ProviderFormData,
  ({ data }) => data,
);

export const useProviderFormMutate = createSelector(
  ProviderFormData,
  ({ mutate }) => mutate,
);
